import { handleApi } from "./common";

export const REFER_EARN_API_CONSTANTS = {
  activeCampaigns: "/api/venus/api/referral/user/active/campaigns",
  refereeList: "/api/venus/api/referral/user/referee/list",
  walletBalance: "/api/venus/api/referral/user/wallet/balance?",
  walletTransactions: "/api/venus/api/referral/user/wallet/transactions",
  walletTransfer: "/api/venus/api/referral/user/wallet/create/transfer",
  tnc: "/api/venus/api/referral/campaigns/get/tnc",
  updateNotification: "/api/venus/api/referral/user/update/notification",
};

export const fetch_campaigns = async (Api, token) => {
  const activeCampaignsData = await Api.get(
    REFER_EARN_API_CONSTANTS.activeCampaigns,
    {},
    {},
    token
  );
  return handleApi(activeCampaignsData);
};

export const fetch_referee_list = async (Api, token) => {
  const response = await Api.get(
    REFER_EARN_API_CONSTANTS.refereeList,
    {},
    {},
    token
  );
  return handleApi(response);
};

export const fetch_wallet_transactions = async (Api, token) => {
  const response = await Api.get(
    REFER_EARN_API_CONSTANTS.walletTransactions,
    {},
    {},
    token
  );
  return handleApi(response);
};

export const fetch_wallet_balance = async (Api, token) => {
  const response = await Api.get(
    REFER_EARN_API_CONSTANTS.walletBalance,
    {},
    {},
    token
  );
  return handleApi(response);
};

export const trigger_wallet_transfer = async (Api, body = {}, token) => {
  const response = await Api.post(
    REFER_EARN_API_CONSTANTS.walletTransfer,
    body,
    {},
    token
  );
  return handleApi(response);
};

export const fetch_tnc_points = async (Api, token) => {
  const response = await Api.get(REFER_EARN_API_CONSTANTS.tnc, {}, {}, token);
  return handleApi(response);
};

export const update_notification = async (Api, body = {}, token) => {
  const response = await Api.get(
    REFER_EARN_API_CONSTANTS.updateNotification,
    body,
    {},
    token
  );
  return handleApi(response);
};
